import { Component, Input } from '@angular/core';
import { InspectionVolumeCase } from '@authority-labs/api-interfaces';
import { CheckBasicCaseComponent } from '../check-basic-case/check-basic-case.component';

@Component({
  selector: 'authority-labs-check-dimensions-case',
  templateUrl: './check-dimensions-case.component.html',
  styleUrls: ['./check-dimensions-case.component.scss']
})
export class CheckDimensionsCaseComponent extends CheckBasicCaseComponent {
  @Input() inspection: InspectionVolumeCase;
}
